/**
 * Author and copyright: Stefan Haack (https://shaack.com)
 */

import {Component} from "../../../lib/cm-web-modules/app/Component.js"
import {Sample} from "../../../lib/cm-web-modules/audio/Sample.js"
import {consoleMessageTopics} from "../../../lib/chess-console/ChessConsole.js"

export class Sound extends Component {

    constructor(chessConsole, props) {
        super(props)
        this.chessConsole = chessConsole
        this.sprites = {
          "10s_left": new Sample("assets/sounds/gsfx/10s_left.mp3", {gain: 0.5}),
          "capture": new Sample("assets/sounds/gsfx/capture.mp3", {gain: 0.5}),
          "check": new Sample("assets/sounds/gsfx/check.mp3", {gain: 0.5}),
          "click": new Sample("assets/sounds/gsfx/click.mp3", {gain: 0.5}),
          "defeat": new Sample("assets/sounds/gsfx/defeat.mp3", {gain: 0.5}),
          "draw": new Sample("assets/sounds/gsfx/draw.mp3", {gain: 0.5}),
          "draw_offer": new Sample("assets/sounds/gsfx/draw_offer.mp3", {gain: 0.5}),
          "game_started": new Sample("assets/sounds/gsfx/game_started.mp3", {gain: 0.5}),
          "move": new Sample("assets/sounds/gsfx/move.mp3", {gain: 0.5}),
          "rematch_offer": new Sample("assets/sounds/gsfx/rematch_offer.mp3", {gain: 0.5}),
          "selector": new Sample("assets/sounds/gsfx/selector.mp3", {gain: 0.5}),
          "victory": new Sample("assets/sounds/gsfx/victory.mp3", {gain: 0.5}),

        }
        this.chessConsole.messageBroker.subscribe(consoleMessageTopics.initGame, () => {
            this.play("game_started")
        })
        this.chessConsole.messageBroker.subscribe("playSound", (data) => {
            this.play(data.name)
        })
        this.chessConsole.messageBroker.subscribe(consoleMessageTopics.legalMove, (data) => {
            const chess = this.chessConsole.state.chess
            const flags = data.moveResult.flags
            if (flags.indexOf("p") !== -1) {
                // this.play("promotion")
            } else if (flags.indexOf("c") !== -1) {
                this.play("capture")
            } else if (flags.indexOf("k") !== -1 || flags.indexOf("q") !== -1) {
                // this.play("castle")
            } else {
                this.play("move")
            }
            if (chess.inCheckmate() || chess.inCheck()) {
                setTimeout(() => {
                    this.play("check")
                }, 300) // with delay after move sound
            }
        })
        this.chessConsole.messageBroker.subscribe(consoleMessageTopics.illegalMove, () => {
            this.play("check")
        })
        this.chessConsole.messageBroker.subscribe(consoleMessageTopics.drawOffer, () => {
            this.play("draw_offer")
        })
        this.chessConsole.messageBroker.subscribe(consoleMessageTopics.rematchOffer, () => {
            this.play("rematch_offer")
        })
        this.chessConsole.messageBroker.subscribe(consoleMessageTopics.tenSecondsLeft, () => {
            this.play("10s_left")
        })
        this.chessConsole.messageBroker.subscribe(consoleMessageTopics.drawOutcome, () => {
            this.play("draw")
        })
        this.chessConsole.messageBroker.subscribe(consoleMessageTopics.victoryOutcome, () => {
            this.play("victory")
        })
        this.chessConsole.messageBroker.subscribe(consoleMessageTopics.defeatOutcome, () => {
            this.play("defeat")
        })
        this.chessConsole.messageBroker.subscribe(consoleMessageTopics.moveUndone, () => {
            // this.play("take_back")
        })
        this.chessConsole.messageBroker.subscribe(consoleMessageTopics.gameOver, (data) => {
            setTimeout(() => {
                if (!data.wonColor) {
                    this.play("defeat")
                } else {
                    if (data.wonColor === this.chessConsole.props.playerColor) {
                        this.play("victory")
                    } else {
                        this.play("defeat")
                    }
                }
            }, 500)
        })
    }
    play(soundName) {
        this.sprites[soundName].play()
    }
}
